/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class AuthController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Log-in user by magic link
   *
   * @tags auth-controller
   * @name SendMagicLink
   * @request GET:/api/public/v1/old-auth/login/magic/send-email
   */
  sendMagicLink = (
    query: {
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/public/v1/old-auth/login/magic/send-email`,
      method: "GET",
      query: query,
      ...params,
    });
}
